import { combineActions, handleActions } from 'redux-actions';
import { App as actions } from '../../../Actions';

const initialState: any = {
    isFetching: true,
    account: {
        businessUnitId: 'initial',
        businessUser: {
            email: '',
        },
    },
    integrationKey: '',
    source: '',
    productIdentificationOptions: [],
    tierName: '',
    shops: [],
    configurationScopeTree: [],
    accessError: null,
};

const App = handleActions<any, any>({
    [actions.setGlobalState as any]: (state: any, action: any) => ({
        ...state,
        ...action.payload.state,
    }),
    [combineActions(actions.setBusinessUnitId, actions.setBusinessUser) as any]: (state: any, action: any) => {
        state.account = { ...state.account, ...action.payload };
        return state;
    },
    [actions.setAccessErrorSuccess as any]: (state: any, action: any) => ({
        ...state,
        ...action.payload,
    }),
}, initialState);

export default App;
